import { useMemo } from "react";
import { useTranslation } from 'react-i18next';
import { colorSchemeType } from "utils/types";

import "./ColorSidebarMainContent.scss";

import TabsComponent from "components/uiComponents/Tabs/TabComponent";
import ConditionColorContent from "../SidebarTabsContent/ConditionColorContent";
import GradientColorContent from "../SidebarTabsContent/GradientColorContent";
import useSetting from "components/sidebarComponents/SidebarProject/use-settings";

const ColorSidebarMainContentSetting = () => {
  const { changeTabHandler, temporarySetting } = useSetting();
  const { t } = useTranslation();

  const currentOpenColorTab = temporarySetting.metaData?.currentOpenTab;

  const tabsArray = useMemo(
    () => [
      {
        text: t('one_color'),
        id: colorSchemeType.conditionalColor,
      },
      {
        text: t('gradient'),
        id: colorSchemeType.gradient,
      },
    ],
    []
  );

  const tabContentObject = useMemo(() => {
    return {
      [colorSchemeType.conditionalColor]: <ConditionColorContent />,
      [colorSchemeType.gradient]: <GradientColorContent />,
    };
  }, []);

  return (
    <div className="color-sidebar">
      <div className="color-sidebar-tabs">
        <TabsComponent
          defaultId={currentOpenColorTab}
          tabsArray={tabsArray}
          onSetTab={changeTabHandler}
          tabsContentObject={tabContentObject}
        />
      </div>
    </div>
  );
};

export default ColorSidebarMainContentSetting;
